export const PAGE_NOT_FOUND_ERROR = 'Page could not be found.';
export const POST_NOT_FOUND_ERROR = 'The requested post could not be found.';
export const APOLLO_FETCH_ERROR =
    'An error occurred while fetching data from the server.';
